import React from 'react';
import { DONNA_WORLD, WorkspaceWindowModel } from './types';

const HUB_R = 72;

function windowAnchor(w: WorkspaceWindowModel) {
  return { x: w.x + w.width / 2, y: w.y + 24 };
}

function hubEdgeToward(tx: number, ty: number) {
  const dx = tx - DONNA_WORLD.hubX;
  const dy = ty - DONNA_WORLD.hubY;
  const len = Math.hypot(dx, dy) || 1;
  return {
    x: DONNA_WORLD.hubX + (dx / len) * HUB_R,
    y: DONNA_WORLD.hubY + (dy / len) * HUB_R,
  };
}

export const WorkspaceConnections: React.FC<{ windows: WorkspaceWindowModel[] }> = ({ windows }) => (
  <svg
    className="absolute inset-0 pointer-events-none overflow-visible"
    width={DONNA_WORLD.width}
    height={DONNA_WORLD.height}
    aria-hidden
  >
    <defs>
      <linearGradient id="donna-link-grad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#22d3ee" stopOpacity="0.55" />
        <stop offset="100%" stopColor="#6366f1" stopOpacity="0.35" />
      </linearGradient>
    </defs>
    {windows.map((w) => {
      const target = windowAnchor(w);
      const start = hubEdgeToward(target.x, target.y);
      const midX = (start.x + target.x) / 2;
      const midY = (start.y + target.y) / 2 - 40;
      const d = `M ${start.x} ${start.y} Q ${midX} ${midY} ${target.x} ${target.y}`;
      return (
        <g key={w.id}>
          <path d={d} fill="none" stroke="url(#donna-link-grad)" strokeWidth={2} opacity={0.45} />
          <path
            d={d}
            fill="none"
            stroke="#22d3ee"
            strokeWidth={1}
            strokeDasharray="6 10"
            opacity={0.35}
            className="donna-link-dash"
          />
          <circle cx={target.x} cy={target.y} r={4} fill="#22d3ee" opacity={0.7} />
        </g>
      );
    })}
    <circle
      cx={DONNA_WORLD.hubX}
      cy={DONNA_WORLD.hubY}
      r={HUB_R + 18}
      fill="none"
      stroke="#22d3ee"
      strokeWidth={1}
      opacity={0.12}
      className="donna-hub-ring"
    />
  </svg>
);
